import React from 'react';
import { useParams } from 'react-router-dom';
import ObjectViewLayout from '@/components/layouts/ObjectViewLayout';
import { FolioErrorBoundary } from '@/components/layouts/FolioErrorBoundary';
import { DealDialogs } from '@/components/views/DealView/DealDialogs';
import { DebtorTabView } from './DebtorTabView';
import { DebtorsAboutCard } from './DebtorsAboutCard';

const DebtorViewWrapper = () => {
	const { dealId } = useParams();

	return (
		<ObjectViewLayout
			tabView={<DebtorTabView />}
			aboutCard={
				<FolioErrorBoundary
					dealId={dealId}
					key={`${dealId}-debtors`}
					message='Error loading content'
					context='DebtorViewWrapper'
				>
					<DebtorsAboutCard />
				</FolioErrorBoundary>
			}
		>
			<DealDialogs />
		</ObjectViewLayout>
	);
};

DebtorViewWrapper.displayName = 'DebtorViewWrapper';

export default DebtorViewWrapper;
